import { Product } from '@/types/product';

export const products: Product[] = [
{
id: 1,
name: "Pure Vitamin C Serum",
category: "SPECIALTY",
    description: "Brightening and firming treatment with <strong>Korean patented water-free technology</strong> to maximize stability and absorption. Housed in <strong>oxygen-blocking airless packaging</strong> to protect Vitamin C from oxidation and ensure full potency from first to last pump.  30 mL / 1.01 fl. oz.",
price: 38,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/vitamin_main_1.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/vitamin_main_1.webp", 
alt: "SUMSAE Pure Vitamin C Serum bottle", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/acontent_1.webp", 
alt: "Visible results of SUMSAE Pure Vitamin C Serum", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/acontent_2.webp", 
alt: "Why choose SUMSAE Pure Vitamin C Serum comparison chart", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/acontent_3.webp", 
alt: "Before and after 4 weeks of SUMSAE Pure Vitamin C Serum", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/acontent_4.webp", 
alt: "Triple barrier shield technology preserving pure Vitamin C", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/acontent_5.webp", 
alt: "SUMSAE Pure Vitamin C Serum backed by Korean patent technology", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-1-gallery-1.webp", 
alt: "SUMSAE Vitamin C Serum packaging box", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-1-gallery-2.webp", 
alt: "SUMSAE Vitamin C Serum product collection", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-1-gallery-3.webp", 
alt: "SUMSAE Vitamin C Serum with citrus fruits and herbs", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-1-gallery-4.webp", 
alt: "SUMSAE Pure Vitamin C Serum with natural ingredients", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-1-gallery-5.webp", 
alt: "SUMSAE Vitamin C Serum texture close-up", 
type: "product" 
},
{ url: "https://images.unsplash.com/photo-1522262590532-a991489a0253?w=800&auto=format&fit=crop&q=60", 
alt: "Skin Before Vitamin C Serum", 
type: "before" 
},
{ url: "https://images.unsplash.com/photo-1521837670401-2bd39da1c0b3?w=800&auto=format&fit=crop&q=60", 
alt: "Skin After Vitamin C Serum", 
type: "after" 
}
],
details: [
"10.5% stabilized Vitamin C for powerful brightening",
"No added water",
"Housed in airless packaging to prevent oxidation",
"Soothes with oat-derived SymCalmin",
"Helps reduce dark spots and even skin tone",
"Provides antioxidant protection against environmental damage"
],
howToUse: `1. Apply a small amount (2-3 pumps) to your face and neck after cleansing and toning.
2. Gently massage into skin until fully absorbed.
3. Use daily for best results.
4. Always apply sunscreen during the day when using this product.
5. Store in a cool, dry place away from direct sunlight.`,
ingredients: `Pure Vitamin C, 3-O-Ethyl Ascorbic Aicd, Bisabolol, Oat-drived Symcalmin, CS-peptide-5, Centella asiatica extract,Beta glucan, Hyaluronate Acid, gamma-PGA, etc.`,
status: 'available'
},
{
id: 2,
name: "Pore Control Cleansing Gel Foam",
category: "CLEANSING",
description: "Deep-cleansing gel that helps <strong>tighten pores</strong> and <strong>control oil</strong> with <strong>Green Tea</strong>, <strong>Niacinamide</strong>, <strong>Pomegranate</strong>, and <strong>Chestnut Shell Extract</strong>. User testing showed up to <strong>35% sebum reduction</strong> and <strong>visible pore minimization</strong> after 8 weeks. Gentle, effective formula that lifts makeup and impurities without drying.  155 mL / 5.24 fl. oz.",
price: 20,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_1.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_1.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleanser_content_1.webp", 
alt: "Clears pores, deep clean gentle gel-to-foam cleanser", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleanser_content_2.webp", 
alt: "Pore size reduced by 50% in 8 weeks consumer test results", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleanser_content_3.webp", 
alt: "100% of users agree skin feels deeply cleansed yet gentle", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleanser_content_4.webp", 
alt: "Key ingredients: green tea, pomegranate, lavender, chestnut shell, lingonberry, mulberry bark", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleanser_content_5.webp", 
alt: "Proven to remove various makeup residues", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_2.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam - View 2", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_3.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam - View 3", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_4.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam - View 4", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_5.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam - View 5", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_6.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam - View 6", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_7.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam - View 7", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_8.webp", 
alt: "SUMSAE Pore Control Cleansing Gel Foam - View 8", 
type: "product" 
},
{ url: "https://images.unsplash.com/photo-1513263000467-c5cd8c31dd39?w=800&auto=format&fit=crop&q=60", 
alt: "Skin Before Cleansing Gel", 
type: "before" 
},
{ url: "https://images.unsplash.com/photo-1594125311687-3b1b3eafa9f4?w=800&auto=format&fit=crop&q=60", 
alt: "Skin After Cleansing Gel", 
type: "after" 
}
],
details: [
"pH-balanced formula suitable for all skin types",
"Gently removes impurities without stripping skin",
"Enriched with chamomile and aloe vera"
],
howToUse: `1. Wet your face with lukewarm water.
2. Apply a small amount of gel to your palms and work into a rich lather.
3. Gently massage onto your face in circular motions for 30-60 seconds.
4. Rinse thoroughly with lukewarm water.
5. Pat dry with a clean towel.
6. Use morning and evening as part of your skincare routine.`,
ingredients: `Water, Cocamidopropyl Betaine, Sodium Lauroyl Methyl Isethionate, Glycerin, Chamomilla Recutita (Chamomile) Flower Extract, Aloe Barbadensis Leaf Juice, Sodium Chloride, Citric Acid, Phenoxyethanol, Ethylhexylglycerin, Fragrance.`,
status: 'available'
},
{
id: 3,
name: "Isoflavone Hydrating Essence",
category: "ESSENCE",
description: "<strong>Brightens, firms, and deeply hydrates</strong> with plant-based actives including <strong>Isoflavone (Genistein)</strong> and γ-PGA, a natural moisturizer derived from fermented soybeans (a traditional Korean superfood known as <strong>Chungkukjang</strong>). Formulated to support <strong>skin elasticity</strong>, <strong>boost moisture retention</strong>, and help improve overall <strong>skin clarity</strong>. Safe for sensitive skin.  30 mL / 1.01 fl. oz.",
price: 32,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_1.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_1.webp", 
alt: "SUMSAE Isoflavone Hydrating Essence", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_content_1.webp", 
alt: "All-Day Hydration for All-Day Glow - Isoflavone Hydrating Essence", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_content_2.webp", 
alt: "Powerful duo for skin radiance - Genistein and gamma-PGA", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_content_3.webp", 
alt: "Benefits of Isoflavone Hydrating Essence", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_content_4.webp", 
alt: "Key ingredients of Isoflavone Hydrating Essence", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_2.webp", 
alt: "SUMSAE Isoflavone Hydrating Essence - View 2", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_3.webp", 
alt: "SUMSAE Isoflavone Hydrating Essence - View 3", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_4.webp", 
alt: "SUMSAE Isoflavone Hydrating Essence - View 4", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_5.webp", 
alt: "SUMSAE Isoflavone Hydrating Essence - View 5", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_6.webp", 
alt: "SUMSAE Isoflavone Hydrating Essence - View 6", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_7.webp", 
alt: "SUMSAE Isoflavone Hydrating Essence - View 7", 
type: "product" 
},
{ url: "https://images.unsplash.com/photo-1525904097878-94fb15835963?w=800&auto=format&fit=crop&q=60", 
alt: "Skin Before Hydrating Essence", 
type: "before" 
},
{ url: "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=800&auto=format&fit=crop&q=60", 
alt: "Skin After Hydrating Essence", 
type: "after" 
}
],
details: [
"Isoflavone Genistein: Plant based phytoestrogen that helps boost collagen production improving elasticity and reducing visible fine lines",
"Polyglutamic Acid γ PGA: A natural moisturizing peptide created during Korean soybean fermentation clinically shown to hold more moisture than hyaluronic acid",
"Clinically Verified Hydration: After 4 weeks skin showed 99 percent higher hydration brighter tone and improved resilience",
"Soothing Barrier Care: With Centella Asiatica Beta Glucan and Panthenol to calm irritation repair and protect the skin barrier",
"Lightweight K Beauty Texture: Non sticky fast absorbing essence that layers perfectly under moisturizer or sunscreen"
],
howToUse: `1. After cleansing and toning, apply 2-3 drops to your palm.
2. Gently pat the essence onto your face and neck.
3. Allow to absorb completely before applying other products.
4. Use morning and evening.
5. Follow with your regular moisturizer and sunscreen during the day.`,
ingredients: `Fermented Soybean Extract, Glycine Soja (Soybean) Isoflavones, Hyaluronic Acid, Sodium Hyaluronate, Butylene Glycol, Glycerin, Niacinamide, Panthenol, Adenosine, Allantoin, Dipotassium Glycyrrhizate, Water, Phenoxyethanol, Ethylhexylglycerin.`,
status: 'available'
},
{
id: 8,
name: "3+ Marine Glow Ampoule Spray",
category: "MIST",
description: "A multi-tasking ampoule spray that works as a <strong>toner, mist, and makeup fixer</strong> in one. Delivers an instant <strong>glass-skin glow</strong> with a fine micro-mist that applies smoothly and evenly. Formulated with <strong>Niacinamide</strong>, <strong>Tranexamic Acid</strong>, <strong>Vitamin C derivative</strong>, and <strong>Kelp Extract</strong> to help visibly brighten, hydrate, and refresh dull-looking skin. Creates a lightweight moisture veil to keep skin feeling soft, dewy, and comfortable throughout the day. Use before or after makeup for a fresh, radiant finish. 80 mL / 2.7 fl. oz.",
price: 20,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_main1.webp?v=2",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_main1.webp?v=2",
alt: "SUMSAE 3+ Marine Glow Ampoule Spray - main 1",
type: "product"
},
      { url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_listing_1.webp",
        alt: "SUMSAE 3+ Marine Glow Ampoule Spray - listing 1",
        type: "product"
      },
      { url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_listing_2.webp",
        alt: "SUMSAE 3+ Marine Glow Ampoule Spray - listing 2",
        type: "product"
      },
      { url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_listing_3.webp",
        alt: "SUMSAE 3+ Marine Glow Ampoule Spray - listing 3",
        type: "product"
      },
      { url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_listing_4.webp",
        alt: "SUMSAE 3+ Marine Glow Ampoule Spray - listing 4",
        type: "product"
      },
      { url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_listing_5.webp",
        alt: "SUMSAE 3+ Marine Glow Ampoule Spray - listing 5",
        type: "product"
      },
      { url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_listing_6.webp",
        alt: "SUMSAE 3+ Marine Glow Ampoule Spray - listing 6",
        type: "product"
      }
],
details: [
"3-in-1: Toner, Mist, and Makeup Fixer",
"Fine micro-mist for smooth, even application",
"Niacinamide and Tranexamic Acid for brightening",
"3-O-Ethyl Ascorbic Acid (Vitamin C derivative) for radiance",
"Kelp Extract for hydration and mineral nourishment",
"Lightweight moisture veil for all-day dewiness"
],
howToUse: `1. Hold the bottle about 20cm from your face.
2. Close your eyes and spray evenly across the face.
3. Use as a toner after cleansing by spraying onto a cotton pad.
4. Use as a mist throughout the day to refresh and hydrate.
5. Use as a makeup fixer after completing your makeup routine.
6. Can also be used on body for a refreshing glow.`,
ingredients: `Water, Kelp Extract, Niacinamide, 3-O-Ethyl Ascorbic Acid, Tranexamic Acid, Glycerin, Butylene Glycol, Panthenol, Allantoin, Sodium Hyaluronate, Beta-Glucan, Centella Asiatica Extract, Phenoxyethanol, Ethylhexylglycerin.`,
status: 'available'
},
{
id: 5,
name: "Hydration & Brightening Duo",
category: "DUO",
description: "A perfectly paired skincare duo designed to <strong>deeply hydrate</strong> while <strong>visibly brightening</strong> and improving overall skin radiance for a <strong>healthy-looking glow</strong>. Features <strong>Isoflavone Hydrating Essence</strong> to prep skin and <strong>Pure Vitamin C Serum</strong> with no added water formula for maximum potency.",
price: 59.50,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/bundle2.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/bundle2.webp",
alt: "SUMSAE Hydration & Brightening Duo", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-1.webp", 
alt: "Pure Vitamin C Serum in duo", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_1.webp", 
alt: "Isoflavone Hydrating Essence in duo", 
type: "product" 
}
],
details: [
"Save 15% compared to buying individually (Regular price: $70)",
"Isoflavone Hydrating Essence - Replenishes moisture & preps skin",
"Pure Vitamin C Serum - 10.5% stabilized Vitamin C for brightening",
"No Added Water formula maximizes potency of active ingredients",
"Layering system for better absorption without irritation",
"Perfect for daily use on all skin types",
"Clean, minimal Korean skincare approach"
],
howToUse: `Step 1: After cleansing, apply Isoflavone Hydrating Essence to replenish moisture and prep the skin.

Step 2: Layer Pure Vitamin C Serum over the essence. The essence supports better absorption of the serum.

Frequency: Suitable for daily use, morning and evening. Always apply sunscreen during the day.`,
ingredients: `This duo contains two separate products:

Isoflavone Hydrating Essence: Isoflavone Genistein, Polyglutamic Acid (γ-PGA), Centella Asiatica, Beta Glucan, Panthenol.

Pure Vitamin C Serum: 10.5% Pure Vitamin C (Ascorbic Acid), Adenosine, Panthenol, Beta-Glucan in Propanediol base (no water).`,
status: 'available'
},
{
id: 4,
name: "Essential K-Beauty Trio",
category: "BUNDLE",
  description: "Essential trio featuring <strong>10.5% Pure Vitamin C Serum</strong> with water-free Korean technology for brightening and anti-aging, <strong>Pore Control Cleansing Gel</strong> that reduces sebum by 35% with green tea and niacinamide, and <strong>Isoflavone Hydrating Essence</strong> with fermented soybean actives for deep hydration and firmness. Complete skincare routine in one bundle.",
  price: 72,
  image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/trio_main_1.webp",
  images: [
  { url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/trio_main_1.webp", 
  alt: "SUMSAE Essential K-Beauty Trio", 
  type: "product" 
  },
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-1.webp", 
alt: "Pure Vitamin C Serum in bundle", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_1.webp", 
alt: "Isoflavone Hydrating Essence in bundle", 
type: "product" 
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_1.webp", 
alt: "Pore Control Cleansing Gel Foam in bundle", 
type: "product" 
}
],
details: [
"Save 20% compared to buying individually (Regular price: $90)",
"Pure Vitamin C Serum - Brightening & anti-aging",
"Pore Control Cleansing Gel Foam - Deep cleansing & pore control",
"Isoflavone Hydrating Essence - Intense hydration & firming",
"Complete morning and evening routine",
"Perfect for all skin types",
"Ideal starter kit for K-beauty beginners"
],
howToUse: `Morning Routine:
1. Cleanse with Pore Control Cleansing Gel Foam
2. Apply Isoflavone Hydrating Essence
3. Follow with Pure Vitamin C Serum
4. Apply moisturizer and sunscreen

Evening Routine:
1. Cleanse with Pore Control Cleansing Gel Foam
2. Apply Isoflavone Hydrating Essence
3. Apply Pure Vitamin C Serum
4. Follow with moisturizer`,
  ingredients: `This bundle contains three separate products. Please refer to individual product ingredient lists for detailed information.`,
  status: 'available'
},
{
id: 9,
name: "Radiance & Glow Duo",
category: "DUO",
description: "Our two hero products in one set. <strong>Waterless Pure Vitamin C Serum</strong> brightens and firms with 10.5% stabilized Vitamin C, while the <strong>3+ Marine Glow Ampoule Spray</strong> hydrates and refreshes as a toner, mist, and makeup fixer. <strong>Brighten, hydrate, and refresh for a radiant-looking glow.</strong>",
price: 51,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/duo_main_1.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/duo_main_1.webp",
alt: "SUMSAE Radiance & Glow Duo - Pure Vitamin C Serum and 3+ Marine Glow Ampoule Spray",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/vitamin_main_1.webp",
alt: "SUMSAE Waterless Pure Vitamin C Serum",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_main1.webp?v=2",
alt: "SUMSAE 3+ Marine Glow Ampoule Spray",
type: "product"
}
],
details: [
"Save 15% compared to buying individually (Regular price: $62)",
"Waterless Pure Vitamin C Serum - 10.5% stabilized Vitamin C for brightening",
"3+ Marine Glow Ampoule Spray - Toner, mist, and makeup fixer in one",
"Treat then refresh for an instant glass-skin glow",
"Airless packaging keeps Vitamin C fully potent",
"Perfect for daily use on all skin types"
],
howToUse: `Step 1: After cleansing, mist 3+ Marine Glow Ampoule Spray over the face to hydrate and prep skin.

Step 2: Apply Waterless Pure Vitamin C Serum (2-3 pumps) and press gently into skin.

Step 3: Finish with a light mist any time of day, or over makeup, for a dewy glow.

Frequency: Suitable for daily use, morning and evening. Always apply sunscreen during the day.`,
ingredients: `This duo contains two separate products:

Pure Vitamin C Serum: 10.5% Pure Vitamin C, 3-O-Ethyl Ascorbic Acid, Bisabolol, Oat-derived SymCalmin, CS-peptide-5, Centella Asiatica Extract, Beta Glucan, Hyaluronic Acid, gamma-PGA.

3+ Marine Glow Ampoule Spray: Water, Kelp Extract, Niacinamide, 3-O-Ethyl Ascorbic Acid, Tranexamic Acid, Glycerin, Butylene Glycol, Panthenol, Allantoin, Sodium Hyaluronate, Beta-Glucan, Centella Asiatica Extract.`,
status: 'available'
},
{
id: 10,
name: "Daily Glow 3-Step Routine",
category: "BUNDLE",
description: "<strong>Cleanse, Treat, Refresh.</strong> A simple three-step daily routine with the <strong>Pore Control Cleansing Gel Foam</strong> to clear pores and control oil, <strong>Waterless Pure Vitamin C Serum</strong> to brighten and firm, and the <strong>3+ Marine Glow Ampoule Spray</strong> to hydrate and set your glow.",
price: 64,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/daily_glow_main_1.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/daily_glow_main_1.webp",
alt: "SUMSAE Daily Glow 3-Step Routine",
type: "product"
},

{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_1.webp",
alt: "Pore Control Cleansing Gel Foam in routine set",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/vitamin_main_1.webp",
alt: "Waterless Pure Vitamin C Serum in routine set",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_main1.webp?v=2",
alt: "3+ Marine Glow Ampoule Spray in routine set",
type: "product"
}
],
details: [
"Save 20% compared to buying individually (Regular price: $82)",
"Step 1 Cleanse - Pore Control Cleansing Gel Foam, up to 35% sebum reduction",
"Step 2 Treat - Waterless Pure Vitamin C Serum for brightening & firming",
"Step 3 Refresh - 3+ Marine Glow Ampoule Spray as toner, mist, and makeup fixer",
"Complete morning and evening routine in three easy steps",
"Great for oily, combination, and dull-looking skin"
],
howToUse: `Morning Routine:
1. Cleanse with Pore Control Cleansing Gel Foam
2. Mist 3+ Marine Glow Ampoule Spray as a toner
3. Apply Waterless Pure Vitamin C Serum
4. Finish with sunscreen, then mist over makeup to set

Evening Routine:
1. Cleanse with Pore Control Cleansing Gel Foam
2. Mist 3+ Marine Glow Ampoule Spray
3. Apply Waterless Pure Vitamin C Serum`,
ingredients: `This bundle contains three separate products. Please refer to individual product ingredient lists for detailed information.`,
status: 'available'
},
{
id: 11,
name: "Complete Korean Skincare Routine",
category: "BUNDLE",
description: "<strong>4-Step Cleanse, Hydrate, Treat & Glow Routine.</strong> Our full lineup in one set: <strong>Pore Control Cleansing Gel Foam</strong>, <strong>Isoflavone Hydrating Essence</strong>, <strong>Waterless Pure Vitamin C Serum</strong>, and the <strong>3+ Marine Glow Ampoule Spray</strong> for a complete Korean skincare routine from cleanse to glow.",
price: 84,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/routine_main_1.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/routine_main_1.webp",
alt: "SUMSAE Complete Korean Skincare Routine",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/cleansing_1.webp",
alt: "Pore Control Cleansing Gel Foam in complete routine",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/essence_1.webp",
alt: "Isoflavone Hydrating Essence in complete routine",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/vitamin_main_1.webp",
alt: "Waterless Pure Vitamin C Serum in complete routine",
type: "product"
},
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/mist_main1.webp?v=2",
alt: "3+ Marine Glow Ampoule Spray in complete routine",
type: "product"
}
],
details: [
"Save 30% compared to buying individually (Regular price: $110)",
"Step 1 Cleanse - Pore Control Cleansing Gel Foam",
"Step 2 Hydrate - Isoflavone Hydrating Essence with fermented soybean actives",
"Step 3 Treat - Waterless Pure Vitamin C Serum, 10.5% stabilized Vitamin C",
"Step 4 Glow - 3+ Marine Glow Ampoule Spray as toner, mist, and makeup fixer",
"Our best value set and the full SUMSAE routine",
"Suitable for all skin types"
],
howToUse: `Morning Routine:
1. Cleanse with Pore Control Cleansing Gel Foam
2. Mist 3+ Marine Glow Ampoule Spray as a toner
3. Apply Isoflavone Hydrating Essence
4. Apply Waterless Pure Vitamin C Serum
5. Finish with sunscreen, then mist over makeup to set

Evening Routine:
1. Cleanse with Pore Control Cleansing Gel Foam
2. Mist 3+ Marine Glow Ampoule Spray
3. Apply Isoflavone Hydrating Essence
4. Apply Waterless Pure Vitamin C Serum`,
ingredients: `This set contains four separate products. Please refer to individual product ingredient lists for detailed information.`,
status: 'available'
},
{
id: 6,
name: "Aqua Memory Toner",
category: "TONER",
description: "A lightweight toner formulated with <strong>Damask Rose Water</strong> to soothe and balance the skin. Strengthens the skin's moisture barrier to reduce water loss and keep skin hydrated. Enriched with <strong>Hydracoat</strong>, <strong>Lipidamino</strong> (5 essential amino acids), and <strong>Betaine</strong> to visibly improve skin texture and hydration.  155 mL / 5.24 fl. oz.",
price: 26,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-4.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-4.webp", 
alt: "SUMSAE Aqua Memory Toner bottle", 
type: "product" 
},
{ url: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=800&auto=format&fit=crop&q=60", 
alt: "Skin Before Toner", 
type: "before" 
},
{ url: "https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=800&auto=format&fit=crop&q=60", 
alt: "Skin After Toner", 
type: "after" 
}
],
details: [
"Deep hydration water layer technology",
"pH-balanced formula for optimal skin health",
"Light weight texture that absorbs quickly",
"Refreshing feel without stickiness",
"Suitable for all skin types",
"Prepares skin for subsequent skincare steps"
],
howToUse: `1. After cleansing, apply to a cotton pad or directly to palms.
2. Gently pat onto face and neck, avoiding the eye area.
3. Allow to absorb completely before applying serum or moisturizer.
4. Use morning and evening as part of your skincare routine.
5. Follow with your regular skincare products.`,
ingredients: `Water, Glycerin, Butylene Glycol, Sodium Hyaluronate, Hyaluronic Acid, Panthenol, Allantoin, Trehalose, Dipotassium Glycyrrhizate, Sodium PCA, Beta-Glucan, Centella Asiatica Extract, Chamomilla Recutita Flower Extract, Phenoxyethanol, Ethylhexylglycerin.`,
status: 'coming_soon'
},
{
id: 7,
name: "Aqua Memory Skin Barrier Cream",
category: "MOISTURIZER",
description: "A hydration-reinforcing cream infused with <strong>Damask Rose Water</strong> and <strong>Ceramide</strong> to support a healthy skin barrier. Forms a protective moisture film with <strong>Hydracoat</strong>, <strong>Lipidamino</strong>, and <strong>Squalane</strong> to prevent dryness and improve elasticity. Also contains Niacinamide to brighten and refine skin tone.  60 mL / 2.03 fl. oz.",
price: 35,
image: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-5.webp",
images: [
{ url: "https://peizjxbewbhhxuetdxui.supabase.co/storage/v1/object/public/product-images/product-5.webp", 
alt: "SUMSAE Aqua Memory Skin Barrier Cream jar", 
type: "product" 
},
{ url: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&auto=format&fit=crop&q=60", 
alt: "Skin Before Moisturizer", 
type: "before" 
},
{ url: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=800&auto=format&fit=crop&q=60", 
alt: "Skin After Moisturizer", 
type: "after" 
}
],
details: [
"Moisture bomb technology for intensive hydration",
"Barrier care formula strengthens skin protection",
"Soothing ingredients calm irritated skin",
"Long-lasting hydration throughout the day",
"Rich, luxurious cream texture",
"Suitable for all skin types, especially dry skin"
],
howToUse: `1. Apply as the last step of your skincare routine, morning and evening.
2. Take an appropriate amount and warm between your palms.
3. Gently pat and press into face and neck until fully absorbed.
4. Can be used as a sleeping mask by applying a thicker layer at night.
5. Use daily for optimal barrier protection and hydration.`,
ingredients: `Water, Glycerin, Squalane, Ceramide NP, Sodium Hyaluronate, Hyaluronic Acid, Centella Asiatica Extract, Panthenol, Niacinamide, Allantoin, Trehalose, Shea Butter, Jojoba Oil, Beta-Glucan, Madecassoside, Dipotassium Glycyrrhizate, Tocopherol, Phenoxyethanol, Ethylhexylglycerin.`,
  status: 'coming_soon',
  statusLabel: 'Late 2026 Release'
}
];


export const allProducts = [...products];